import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.InteracEmailResponse,
  (requestParams: vp.InteracEmailRequest) => void,
  () => void,
  vp.Api['fetchInteracEmail'],
];

function useFetchInteracEmail({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.InteracEmailRequest>();
  const [response, setResponse] = useState<vp.InteracEmailResponse>({
    ErrorMessage: '',
    Success: false,
    InteracEmails: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.InteracEmailRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchInteracEmail(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.InteracEmailRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        InteracEmails: {},
      });
    },
    (requestParams: vp.InteracEmailRequest) => api.fetchInteracEmail(requestParams, source),
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchInteracEmail);
